<template>
  <div class="br">
    <div class="br__bg">
      <ElementController @element-updated="updateElement"/>
    </div>
  </div>
</template>

<script>
import ElementController from "@/components/pages/BoardRight/ElementController.vue"

export default {
  components: {
    ElementController
  },
  methods: {
    updateElement(updatedElement) {
      this.$store.dispatch('landing/UPDATE_ELEMENT', updatedElement);
    }
  }
};
</script>


<style scoped>
.br {
  position: fixed;
  /*min-width: 22%;*/
  min-width: 19%;
  height: 100%;
  right: 0;
  top: 3rem;
}
.br__bg {
	max-width: 22%;
  min-height: 100%;
  background-color: var(--grey-2);
  padding: 1rem;
  border: 1px solid var(--grey-1);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
	gap: 1rem;
	margin-left: auto;
  max-width: 305px;
  height: 100%;
}

@media (max-width: 1350px) {
  .br__bg {
    max-width: 20.5rem;
  }
}

@media (max-width: 768px) {
  .br {
    width: 100%;
    max-width: 100%;
    position: relative;
  }
  .br__bg {
    margin: 0;
    width: 100%;
    max-width: 100%;
    padding: 0;
    height: 100%;
    background-color: transparent;
    border: none;

  }
}
</style>






